// import * as React from "react";
// import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
// import CardMedia from "@mui/material/CardMedia";
// import CardContent from "@mui/material/CardContent";
// import CardActions from "@mui/material/CardActions";
// import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
// import IconButton, { IconButtonProps } from "@mui/material/IconButton";
// import Typography from "@mui/material/Typography";
// import { red } from "@mui/material/colors";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import ShareIcon from "@mui/icons-material/Share";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Project } from "./projects";
import { Box, Chip, IconButton } from "@mui/material";
import { useMemo } from "react";
import { ArrowCircleRight } from "@mui/icons-material";
// import { OpenInNew } from "@mui/icons-material";
// import { OpenInNew } from "@mui/icons-material";

// interface ExpandMoreProps extends IconButtonProps {
//   expand: boolean;
// }

const statusToChip = {
  "in-progress": {
    label: "In Progress",
    backgroundColor: "#f2c768",
  },
  prototype: {
    label: "Prototype",
    // light teal
    backgroundColor: "#00bfa5",
  },
  old: {
    // What do you call a code project that's no longer worked on?
    // "Old" is a bit harsh, but "Legacy" is too long.
    // "Retired" is a bit too dramatic.
    // "Archived" is a bit too formal.
    // "Abandoned" is a bit too negative.
    // "Inactive" is a bit too vague.
    // "Deprecated" is a bit too technical.
    // "Discontinued" is a bit too final.
    // "Obsolete" is a bit too strong.
    // "Outdated" is a bit too dismissive.
    // "Superseded" is a bit too formal.
    // "Unsupported" is a bit too negative.
    // Here's some better ones: "Dormant", "Stale", "Dusty", "Neglected", "Forgotten", "Unmaintained", "Unloved", "Unfinished", "Unpolished",

    label: "Unfinished",
    backgroundColor: "grey",
  },
  maintained: {
    label: "Maintained",
    backgroundColor: "#4caf50",
  },
  "needs-updating": {
    label: "Needs Updating",
    backgroundColor: "#ff8059",
  },
};

// const ExpandMore = styled((props: ExpandMoreProps) => {
//   const { expand, ...other } = props;
//   return <IconButton {...other} />;
// })(({ theme, expand }) => ({
//   transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
//   marginLeft: "auto",
//   transition: theme.transitions.create("transform", {
//     duration: theme.transitions.duration.shortest,
//   }),
// }));

const ProjectCard = ({ project }: { project: Project }) => {
  // const [expanded, setExpanded] = React.useState(false);

  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };

  const isGamesPage = useMemo(() => window.location.href.includes("games"), []);

  return (
    <Card
      sx={{
        width: "100%",
        justifyContent: "stretch",
        textTransform: "none",
        textDecoration: "none",
        "&:hover": {
          backgroundColor: "rgba(144, 202, 249, 0.08)",
        },
      }}
      component="a"
      href={project.url}
      target="_blank"
      // ref="noreferrer"

      // how to add target and rel attributes when using component={Button}? (target="_blank" isn't alowed here)
    >
      <CardHeader
        avatar={
          // use the project.logo_url image if available, otherwise use first letter of project.title
          <Avatar
            // sx={{ bgcolor: red[500] }}
            alt={project.title}
            src={project.logo_url}
            sx={{
              ...(project.logo_full
                ? {
                    borderRadius: 0,
                  }
                : {}),

              ...(project.logo_url ? {} : { bgcolor: "white", color: "black" }),
            }}
          >
            {project.title.charAt(0)}
          </Avatar>
        }
        // action={
        //   project.description ? (
        //     <ExpandMore
        //       expand={expanded}
        //       onClick={handleExpandClick}
        //       aria-expanded={expanded}
        //       aria-label="show more"
        //     >
        //       <ExpandMoreIcon />
        //     </ExpandMore>
        //   ) : (
        //     <Box
        //       sx={{
        //         width: 40,
        //         height: 40,
        //       }}
        //     />
        //   )
        // }
        // action={
        //   <IconButton
        //     href={project.url}
        //     target="_blank"
        //     rel="noreferrer"
        //     aria-label="open project"
        //     size="small"
        //   >
        //     <OpenInNew />
        //   </IconButton>
        // }
        title={
          <Box>
            <span
              style={{
                fontWeight: "bold",
                color: "white",
                textDecoration: "none",
              }}
            >
              {project.title}
            </span>
            {project.status && !isGamesPage && (
              <Chip
                label={statusToChip[project.status].label}
                size="small"
                sx={{
                  backgroundColor: statusToChip[project.status].backgroundColor,
                  color: "#121212",
                  marginLeft: 2,
                  fontSize: "0.6rem",
                  padding: "0px 1px",
                  height: 14,
                  float: "right",
                }}
              />
            )}
          </Box>
        }
        subheader={project.subtitle}
        // title should be bold
        titleTypographyProps={{ fontWeight: "bold" }}
        sx={{
          width: "100%",
        }}
        action={
          isGamesPage ? (
            <IconButton
              sx={{
                mt: 0.5,
              }}
            >
              <ArrowCircleRight />
            </IconButton>
          ) : undefined
        }
      />
      {/* {project.description && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {project.description}
            </Typography>
          </CardContent>
        </Collapse>
      )} */}
    </Card>
  );
};

export default ProjectCard;
